module.exports = __webpack_public_path__ + "teqbahn-assets/media/36.3fa51d13.png";